import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {FollowerModel} from './Follower.model';

@injectable()
export class FollowerFactory
  implements BaseDomainFactory<FollowerModel, FollowerModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: FollowerModel.Props): FollowerModel {
    return this.modelsRegistry.put(new FollowerModel(props));
  }
}
